import { getValidCountriesWhenRegionsOptionsUpdate } from '@intelligence/utils/regionSelectUtils';
import { getIsMonthlyRank, getCountriesValues } from '../../../utils';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 组合下拉筛选器
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
  //  单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  CONSOLE_PLATFORM_PLAYSTATION,
  CONSOLE_PLATFORM_NINTENDO,
  CONSOLE_TOP_BEST_SELLING,
} from '@/pages/intelligence/_config/storeRank/config';

import type { IRegion } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsFilter } from '../../../types';

export const getComposedChangedApiValue = (
  apiValue: any,
  filter: IStoreRankDetailsFilter,
  regionsOptions: IRegion[],
  regionsOptionsMap: { [key: string]: IRegion[] },
): any => {
  const rangeTime = apiValue?.[FILTER_RANGE_TIME];
  const platformTop = apiValue?.[FILTER_COMPOSED_SELECT]?.value ?? {};
  const platform = platformTop?.parent ?? CONSOLE_PLATFORM_PLAYSTATION;
  const top = platformTop?.child ?? CONSOLE_TOP_BEST_SELLING;
  // 是否为月粒度榜单
  const isMonthlyRank = getIsMonthlyRank({
    platform,
    top,
    granularity: rangeTime?.granularity ?? 'daily',
  });
  let apiValueTmp: typeof apiValue = { ...apiValue };

  // 月粒度榜单同时支持 日粒度、月粒度，不需要调整 时间粒度，相反 日粒度 则需要调整为日粒度
  if (!isMonthlyRank) {
    apiValueTmp = {
      ...apiValueTmp,
      [FILTER_RANGE_TIME]: {
        ...apiValue?.[FILTER_RANGE_TIME],
        filterType: 'date',
        time_type: 'day',
        granularity: 'daily',
      },
    };
  }

  // if (platform !== filter?.platform || top !== filter?.top) {
  //   const isNintendo = platform === CONSOLE_PLATFORM_NINTENDO;
  //   const composedCountries = apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
  //   const regionsOptions = regionsOptionsMap?.[platform];
  //   const regionsOptionsValues = getCountriesValues(regionsOptions);
  //   let countries: string[] = [];
  //   if (composedCountries?.type === 'single' || isNintendo) {
  //     const currentSingleCountry = composedCountries?.countries?.[0];
  //     countries = regionsOptionsValues?.includes(currentSingleCountry)
  //       ? [currentSingleCountry]
  //       : regionsOptionsValues?.includes('us')
  //         ? ['us']
  //         : regionsOptionsValues?.slice(0, 1);
  //   } else if (composedCountries?.type === 'multiple') {
  //     countries = regionsOptionsValues;
  //   }
  //   apiValueTmp = {
  //     ...apiValueTmp,
  //     [FILTER_COMPOSED_COUNTRY_SELECT]: {
  //       ...apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT],
  //       value: {
  //         ...apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value,
  //         countries,
  //       },
  //     },
  //   };
  // }

  if (platform !== filter?.platform || top !== filter?.top) {
    const isNintendo = platform === CONSOLE_PLATFORM_NINTENDO;
    const composedCountriesSelectValue = apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
    const composedCountriesTypeTmp = isNintendo
      ? 'single'
      : composedCountriesSelectValue?.type || 'multiple';
    let composedCountriesTmp = composedCountriesSelectValue?.countries || [];
    const nextRegionsOptions = regionsOptionsMap?.[platform];
    composedCountriesTmp = getValidCountriesWhenRegionsOptionsUpdate({
      type: composedCountriesTypeTmp,
      countries: composedCountriesTmp,
      regions: regionsOptions,
      nextRegions: nextRegionsOptions,
    });

    apiValueTmp = {
      ...apiValueTmp,
      [FILTER_COMPOSED_COUNTRY_SELECT]: {
        ...apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT],
        value: {
          ...apiValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value,
          type: composedCountriesTypeTmp,
          countries: composedCountriesTmp,
        },
      },
    };
  }

  return apiValueTmp;
};
